<template >
    <div>
        <v-overlay z-index="4" :value="true">
            <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <H3 class="mt-5" style="color: white"> Récupération du fichier en cours ...</H3>
    </div>
</template>

<script>
import Classeur from '@/_models/Classeur.js';

export default {
    async created() {
        const { document_id } = this.$route.params
        const file_url = await this.getFileFromId(document_id);
        window.open(file_url, "_self");
    },

    methods: {
        async getFileFromId(document_id) {
            return Classeur.downloadDocument(document_id);
        },
    },
}
</script>

<style >

</style>